export default ({
  namespaced: true,
  state: {
    step: 0,
    messageStatus: false,
    messageServiceType: 1,
    userMessageToken: ''
  },
  getters: {
    getStep: function (state) {
      return state.step
    },
    getMessageStatus: function (state) {
      return state.messageStatus
    },
    getMessageServiceType: function (state) {
      return state.messageServiceType
    },
    getUserMessageToken: function (state) {
      return state.userMessageToken
    }
  },
  mutations: {
    setStep (state, step = 0) {
      state.step = step
    },
    reset(state) {
      state.step = 0
    },
    setMessageStatus (state, messageStatus = false) {
      state.messageStatus = messageStatus
    },
    setMessageServiceType (state, messageServiceType = 1) {
      state.messageServiceType = messageServiceType
    },
    setUserMessageToken (state, userMessageToken = '') {
      state.userMessageToken = userMessageToken
    }
  }
})
